<template>
  <div>
    <v-tooltip v-if="!isUnarchiving" location="bottom">
      <template #activator="{ props }">
        <v-btn
          v-bind="props"
          :disabled="disabled"
          icon
          variant="text"
          @click="onUnArchiveWorkpackageClick"
        >
          <span class="material-icons">unarchive</span>
        </v-btn>
      </template>
      <span>{{ $t('actions.unArchive') }}</span>
    </v-tooltip>
    <v-progress-circular v-else indeterminate size="25" width="3" />
  </div>
</template>

<script>
import { capitalize } from 'lodash';
import { mapActions, mapState } from 'pinia';
import { useSnackbarStore } from '@/stores/snackbar';
import { useBundlesStore } from '@/stores/bundles';
import { useContextStore } from '@/stores/context';
import { usePermission } from '@/composables/use-permission';

export default {
  props: {
    workpackage: {
      required: true,
      type: Object,
    },
    entity: {
      type: String,
      required: false,
      default: '',
    },
  },
  setup() {
    const bundlesStore = useBundlesStore();
    const { canUnArchiveWorkpackage } = usePermission();
    return { bundlesStore, canUnArchiveWorkpackage };
  },
  data() {
    return {
      isUnarchiving: false,
      message: '',
      offset: null,
      pageSize: null,
    };
  },
  computed: {
    ...mapState(useContextStore, ['clientConfig']),
    disabled() {
      return !this.canUnArchiveWorkpackage;
    },
  },
  created() {
    this.message = this.$t(`notifications.unArchive${capitalize(this.entity)}`, {
      name: this.workpackage.name,
    });
    this.pageSize = this.clientConfig.archivedWorpackages.pageSize;
    this.offset = (this.archivedWorkpackagesCurrentPage - 1) * this.pageSize;
  },
  methods: {
    ...mapActions(useSnackbarStore, ['showSuccess']),
    async onUnArchiveWorkpackageClick() {
      this.isUnarchiving = true;
      await this.bundlesStore.updateBundle({
        bundleId: this.workpackage._id,
        updates: {
          _id: this.workpackage._id,
          archived: false,
          archiveDate: null,
        },
      });
      this.bundlesStore.setSelectedBundleMutation(this.workpackage);
      await Promise.all([
        this.bundlesStore.fetchArchivedBundles({
          limit: this.pageSize,
          offset: this.offset,
        }),
        this.bundlesStore.fetchBundles(),
      ]);
      this.showSuccess(this.message);
    },
  },
};
</script>
